import React, { useState } from 'react';
import { CheckIcon, BarChart3Icon, UsersIcon, ZapIcon } from 'lucide-react';
import Button from './Button';
import Wizard from './Wizard';
import { useTranslation } from '../i18n/useTranslation';
const ValueProps = () => {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const {
    t
  } = useTranslation();
  return <section id="value-props" className="py-16 bg-gray-50" data-id="element-2367">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2368">
        <div className="text-center mb-12" data-id="element-2369">
          <h2 className="text-3xl font-bold mb-4" data-id="element-2370">
            {t('sections.valueProps.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-2371">
            {t('sections.valueProps.subtitle')}
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-2372">
          <div className="bg-white rounded-xl p-8 shadow-card border border-gray-100" data-id="element-2373">
            <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2374">
              <BarChart3Icon className="h-8 w-8 text-primary" data-id="element-2375" />
            </div>
            <h3 className="text-2xl font-bold mb-4" data-id="element-2376">
              {t('sections.valueProps.conversion.title')}
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-2377">
              {t('sections.valueProps.conversion.description')}
            </p>
            <div className="border-t border-gray-100 pt-4" data-id="element-2378">
              <div className="flex items-center justify-between" data-id="element-2379">
                <span className="text-gray-600" data-id="element-2380">
                  {t('sections.valueProps.conversion.metric')}
                </span>
                <span className="text-2xl font-bold text-primary" data-id="element-2381">+27%</span>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl p-8 shadow-card border border-gray-100" data-id="element-2382">
            <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2383">
              <UsersIcon className="h-8 w-8 text-primary" data-id="element-2384" />
            </div>
            <h3 className="text-2xl font-bold mb-4" data-id="element-2385">
              {t('sections.valueProps.aov.title')}
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-2386">
              {t('sections.valueProps.aov.description')}
            </p>
            <div className="border-t border-gray-100 pt-4" data-id="element-2387">
              <div className="flex items-center justify-between" data-id="element-2388">
                <span className="text-gray-600" data-id="element-2389">
                  {t('sections.valueProps.aov.metric')}
                </span>
                <span className="text-2xl font-bold text-primary" data-id="element-2390">+32%</span>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl p-8 shadow-card border border-gray-100" data-id="element-2391">
            <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2392">
              <ZapIcon className="h-8 w-8 text-primary" data-id="element-2393" />
            </div>
            <h3 className="text-2xl font-bold mb-4" data-id="element-2394">
              {t('sections.valueProps.returns.title')}
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-2395">
              {t('sections.valueProps.returns.description')}
            </p>
            <div className="border-t border-gray-100 pt-4" data-id="element-2396">
              <div className="flex items-center justify-between" data-id="element-2397">
                <span className="text-gray-600" data-id="element-2398">
                  {t('sections.valueProps.returns.metric')}
                </span>
                <span className="text-2xl font-bold text-primary" data-id="element-2399">-18%</span>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-xl p-8 shadow-card border border-gray-100" data-id="element-2400">
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-2401">
            <div data-id="element-2402">
              <h3 className="text-2xl font-bold mb-4" data-id="element-2403">
                {t('sections.valueProps.advantage.title')}
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-2404">
                {t('sections.valueProps.advantage.description')}
              </p>
              <ul className="space-y-3 mb-6" data-id="element-2405">
                <li className="flex items-start" data-id="element-2406">
                  <CheckIcon className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" data-id="element-2407" />
                  <span className="ml-3 text-gray-600" data-id="element-2408">
                    {t('sections.valueProps.advantage.features.catalog')}
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2409">
                  <CheckIcon className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" data-id="element-2410" />
                  <span className="ml-3 text-gray-600" data-id="element-2411">
                    {t('sections.valueProps.advantage.features.sales')}
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2412">
                  <CheckIcon className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" data-id="element-2413" />
                  <span className="ml-3 text-gray-600" data-id="element-2414">
                    {t('sections.valueProps.advantage.features.channels')}
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2415">
                  <CheckIcon className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" data-id="element-2416" />
                  <span className="ml-3 text-gray-600" data-id="element-2417">
                    {t('sections.valueProps.advantage.features.analytics')}
                  </span>
                </li>
              </ul>
              <Button variant="primary" size="lg" onClick={() => setIsWizardOpen(true)} data-id="element-2418">
                {t('buttons.getStarted')}
              </Button>
            </div>
            <div className="bg-gray-50 rounded-xl p-6" data-id="element-2419">
              <div className="text-xl font-bold mb-4" data-id="element-2420">
                {t('sections.valueProps.testimonial.title')}
              </div>
              <p className="text-gray-600 italic mb-4" data-id="element-2421">
                "{t('sections.valueProps.testimonial.quote')}"
              </p>
              <div className="flex items-center" data-id="element-2422">
                <div className="w-12 h-12 bg-gray-200 rounded-full mr-4" data-id="element-2423"></div>
                <div data-id="element-2424">
                  <div className="font-bold" data-id="element-2425">
                    {t('sections.valueProps.testimonial.name')}
                  </div>
                  <div className="text-gray-500 text-sm" data-id="element-2426">
                    {t('sections.valueProps.testimonial.position')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Wizard isOpen={isWizardOpen} onClose={() => setIsWizardOpen(false)} data-id="element-2427" />
    </section>;
};
export default ValueProps;